import { Component } from "react";

import _ from "underscore";
import { CELL_TYPES } from "..";
import { numberWithSpaces } from "../../../utilities/formaters";

export default class TableSummary extends Component {
  render() {
    let {
      detailsRenderer,
      selectId,
      itemsFiltered,
      columns,
      actionColumnWidth,
    } = this.props;
    let items = itemsFiltered || [];
    let showDetails = !!detailsRenderer;
    let allowSelections = !!selectId;
    actionColumnWidth = actionColumnWidth ? actionColumnWidth + "px" : "350px";

    let renderColumns = _.filter(columns, (col) => {
      return col.visible === true;
    });

    return (
      <tbody>
        <tr>
          {showDetails ? <td /> : undefined}
          {allowSelections ? <td /> : undefined}
          {renderColumns.map((column, index) => {
            if (
              column.type === CELL_TYPES.money ||
              column.type === CELL_TYPES.number
            ) {
              let amount = 0;

              let keys = column.key.split(".");
              let getValueFunc;
              if (keys.length === 2) getValueFunc = getValue2;
              else if (keys.length === 1) {
                getValueFunc = getValue;
                keys.push("");
              }

              for (let i = 0; i < items.length; i++) {
                const item = items[i];
                amount += Number(getValueFunc(item, keys[0], keys[1]));
              }

              return (
                <td key={"summary" + index}>
                  Sum of all filtered: <br /> {numberWithSpaces(amount)}
                </td>
              );
            }

            if (column.label === "Actions") {
              let cellClass = "action-cell";
              let contentClass = "action-cell__content";
              let actionStyle = { width: actionColumnWidth };

              return (
                <td
                  className={cellClass}
                  style={actionStyle}
                  key={"summary" + index}
                >
                  <div className={contentClass}> </div>
                </td>
              );
            }

            return <td key={"summary" + index} />;
          })}
        </tr>
      </tbody>
    );
  }
}
function getValue(object, key1) {
  return object[key1];
}

function getValue2(object, key1, key2) {
  const val = getValue(object, key1);
  return val ? getValue(val, key2) : undefined;
}
